import * as DocumentApiModels from '@/tsClient/servers/noodleDocuments/document-api-models';

// @todo - always pass in referenceId and referenceType
type ThisDocument =
  & Pick<DocumentApiModels.Document, 'fileName'>
  & Partial<Pick<DocumentApiModels.Document, 'referenceId' | 'referenceType'>> | null;

type Reference = {
  type: string | null;
  id: string | null;
};

const getFileIdFromName = (fileName: string | null): string | null => {
  if (!fileName) return null;
  const match = fileName.match(/-([^.]+)\.pdf$/);
  return match ? match[1] : null;
};

const extractFileReference = (document: ThisDocument): Reference | null => {
  if (document?.referenceType && document.referenceId) {
    return { id: document.referenceId, type: document.referenceType };
  }

  const fileName = document?.fileName || null;

  // Support documents from before the referenceType/referenceId were added
  // @todo - write script to add referenceType/referenceId to existing documents and make sure all endpoints return them.
  if (fileName?.startsWith('customTerms')) {
    const type = 'custom-terms';
    const id = getFileIdFromName(fileName);
    if (id) {
      return { id, type };
    }
  }

  return null;
};

export default extractFileReference;